var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_686_346)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 5C1.75 4.58579 2.06811 4.25 2.46053 4.25L10.0395 4.25C10.4319 4.25 10.75 4.58579 10.75 5C10.75 5.41421 10.4319 5.75 10.0395 5.75L2.46053 5.75C2.06811 5.75 1.75 5.41421 1.75 5Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 19C1.75 18.5858 2.06811 18.25 2.46053 18.25L10.0395 18.25C10.4319 18.25 10.75 18.5858 10.75 19C10.75 19.4142 10.4319 19.75 10.0395 19.75L2.46053 19.75C2.06811 19.75 1.75 19.4142 1.75 19Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 12C13.25 11.5858 13.5681 11.25 13.9605 11.25L21.5395 11.25C21.9319 11.25 22.25 11.5858 22.25 12C22.25 12.4142 21.9319 12.75 21.5395 12.75L13.9605 12.75C13.5681 12.75 13.25 12.4142 13.25 12Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 5C17.25 4.58579 17.6231 4.25 18.0833 4.25L21.4167 4.25C21.8769 4.25 22.25 4.58579 22.25 5C22.25 5.41421 21.8769 5.75 21.4167 5.75L18.0833 5.75C17.6231 5.75 17.25 5.41421 17.25 5Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 19C17.25 18.5858 17.6231 18.25 18.0833 18.25L21.4167 18.25C21.8769 18.25 22.25 18.5858 22.25 19C22.25 19.4142 21.8769 19.75 21.4167 19.75L18.0833 19.75C17.6231 19.75 17.25 19.4142 17.25 19Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 12C1.75 11.5858 2.1231 11.25 2.58333 11.25L5.91667 11.25C6.3769 11.25 6.75 11.5858 6.75 12C6.75 12.4142 6.3769 12.75 5.91667 12.75L2.58333 12.75C2.1231 12.75 1.75 12.4142 1.75 12Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2C14.3431 2 13 3.34315 13 5C13 6.65685 14.3431 8 16 8C17.6569 8 19 6.65685 19 5C19 3.34315 17.6569 2 16 2Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16C14.3431 16 13 17.3431 13 19C13 20.6569 14.3431 22 16 22C17.6569 22 19 20.6569 19 19C19 17.3431 17.6569 16 16 16Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_686_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.3ec5653e726c2925b7cacda7a86f0fd5.svg";
export { ForwardRef as ReactComponent };